import React from "react";
import { VscSettingsGear } from "react-icons/vsc";
import { Link } from "react-scroll";

const NavbarUl = () => {
  return (
    <ul className="hidden lg:flex justify-center gap-8  text-[#000000] hover:cursor-pointer">
      <li className="hover:text-[#E84949]   p-2">
        <Link to="home" spy={true} smooth={true} offset={50} duration={500}>
          Home
        </Link>
      </li>
      <li className=" hover:text-[#E84949]  p-2">
        <Link to="about" spy={true} smooth={true} offset={50} duration={500}>
          About
        </Link>
      </li>
      <li className="flex gap-1  p-2 text-[#E84949] hover:text-black ">
        <Link
          to="projects"
          spy={true}
          smooth={true}
          offset={50}
          duration={500}
          className="flex"
        >
          <div className="hidden  lg:flex w-[24px] top-[4.28%] left-0 bottom-[4%] right-0 font-bold">
            <VscSettingsGear />
            <VscSettingsGear size={20} className="h-[-10px] w-[10px] mt-1" />
          </div>
          Projects
        </Link>
      </li>
      <li className="hover:text-[#E84949]  p-2">
        <Link to="contact" spy={true} smooth={true} offset={50} duration={500}>
          Contact
        </Link>
      </li>
    </ul>
  );
};

export default NavbarUl;
